export default __webpack_public_path__ + "static/media/BGMusic.32256edd.mp3";